import { useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil";
import { twoFaEnabledState } from "oc/states/two-fa-enabled-state";

export const useOcTwoFactorEnabledState = () => {
  const state = useRecoilValue(twoFaEnabledState);
  const setState = useSetRecoilState(twoFaEnabledState);
  const resetState = useResetRecoilState(twoFaEnabledState);

  return {
    state,
    setState,
    resetState,
  };
};

export default useOcTwoFactorEnabledState;
